<template>
  <b-modal
    v-model="isActive"
    has-modal-card
    :can-cancel="false"
    @close="closeModal()"
  >
    <div
      class="modal-card modalCardContainer"
      style="
							position: absolute;
							left: 50%;
							top: 50%;
							transform: translate(-50%, -50%);
					"
    >
      <header
        class="modal-card-head"
        style="background-color: rgba(40, 40, 40, 1); color: white"
      >
        Wichtiger Hinweis
      </header>
      <section
        class="modal-card-body"
        style="padding: 0.5em; color: black"
      >
        <P>
          Sie verwenden eine veraltete Version. Ein Update ist erforderlich.
          Mit "Jetzt updaten" werden Sie abgemeldet und die neue Version wird geladen.
        </P>
      </section>
      <footer
        class="modal-card-foot footerContainer"
        style="background-color: rgba(40, 40, 40, 1); color: white"
      >
        <b-button
          type="is-primary"
          @click="updateNow"
        >
          Jetzt updaten
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>

import { mapGetters } from "vuex";
import {negativeFeedBack, positiveFeedBack} from "@/lib/Toast";
import Parse from "parse/dist/parse.min.js";
import { primePageCache } from "@/lib/versionReload";

export default {
	name: "VersionModal",
	props: ["value"],
	data() {
		return {};
	},
	computed: {
		...mapGetters({
		}),
		isActive: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
	},
	mounted() { },
	methods: {
		closeModal() {
			this.isActive = false;
		},
		async updateNow() {
			this.isLoading = true
			try {
				await Parse.User.logOut()
				positiveFeedBack("Nutzer abgemeldet!")
			}
			catch (e) {
				console.error("couldnt logout the user " + e)
				negativeFeedBack("Abmeldung fehlgeschlagen!")
			}
			await primePageCache("/login")
			window.location.replace("/login")
		}
	}
}

</script>

<style scoped></style>
